import { render, staticRenderFns } from "./ListagemPedidosPorNumProcesso.vue?vue&type=template&id=8e3b2e1e&scoped=true"
import script from "./ListagemPedidosPorNumProcesso.vue?vue&type=script&lang=js"
export * from "./ListagemPedidosPorNumProcesso.vue?vue&type=script&lang=js"
import style0 from "./ListagemPedidosPorNumProcesso.vue?vue&type=style&index=0&id=8e3b2e1e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3b2e1e",
  null
  
)

export default component.exports